<template>
<div>
  <div
      :style="{
        width: fieldWidth,
        height: fieldHeight,
        backgroundColor: fieldBackgroundColor,
        border: fieldBackgroundColor ? '1px solid ' + fieldBackgroundColor : '1px dashed rgba(255,255,255,0.4)'
      }"
      class="clickable d-inline-block color-picker-color-field"
      @click="startColorPicker"
  ></div>
  <div
      :style="{
        width: fieldWidth,
        height: fieldHeight
       }"
      @click="unsetColor"
       class="d-inline-block ml-1 color-remover"
       v-if="fieldBackgroundColor">
    <icon
        type="times"
        class="clickable d-inline-block"
    />
  </div>
  <portal v-if="showColorPicker" to="pageOverlay">
    <color-picker
        v-if="showColorPicker"
        class="position-fixed color-picker-and-field-picker"
        ref="colorpickr"
        :popup-style="true"
        :value="localColor"
        @close="closePicker"
        @save="saveColor"
        @changeColor="updateColor"
        :is-position-absolute="true"
        :event="event"
    />
  </portal>
</div>
</template>

<script>
import ColorPicker from "@/components/widgets/editors/ColorPicker.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "ColorPickerAndField.vue",
  components: {Icon, ColorPicker},
  props: {
    fieldWidth: {type: String, default: '20px'},
    fieldHeight: {type: String, default: '20px'},
    fieldBackgroundColor: {type: String, default: null},
    autoSave: {type: Boolean, default: true},
  },
  data() {
    return {
      showColorPicker: false,
      event: null,
      localColor: null,
      originalColor: null
    };
  },
  watch: {
    fieldBackgroundColor: {
      immediate: true,
      handler() {
        this.setColorFromRemote();
      }
    },
  },
  beforeMount() {
    this.setColorFromRemote();
  },
  methods: {
    unsetColor() {
      this.originalColor = null;
      this.$emit('unsetColor');
      this.showColorPicker = false;
      this.event = null;
    },
    setColorFromRemote() {
      if (this.fieldBackgroundColor && this.fieldBackgroundColor !== this.localColor) {
        this.localColor = this.fieldBackgroundColor;
      }
    },
    closePicker() {
      this.showColorPicker = false;
      this.event = null;
      if(this.originalColor !== this.localColor) {
        this.updateColor(this.originalColor)
      }
    },
    saveColor(color) {
      this.$emit('saveColor', color);
      this.showColorPicker = false;
      this.event = null;
    },
    updateColor(color) {
      if(this.autoSave) {
        this.$emit('saveColor', color);
      } else {
        this.$emit('updateColor', color);
      }
    },
    startColorPicker(event) {
      if(this.showColorPicker) {
        return;
      }
      if(this.fieldBackgroundColor) {
        this.originalColor = this.fieldBackgroundColor;
      }
      this.event = event;
      this.showColorPicker = true;
    }
  }
}
</script>

<style lang="scss">
.color-picker-and-field-picker {
  z-index: 10001 !important;
  font-family: Inter !important;
}
</style>

<style lang="scss" scoped>
.color-remover {
  position: relative;
  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin-top: 1px;
  }
}
</style>